import * as React from 'react';

function SvgFolderPlus(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M.5 3l.04.87a1.99 1.99 0 00-.342 1.311l.637 7A2 2 0 002.826 14H9v-1H2.826a1 1 0 01-.995-.91l-.637-7A1 1 0 012.19 4h11.62a1 1 0 01.996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0013.81 3H9.828a2 2 0 01-1.414-.586l-.828-.828A2 2 0 006.172 1H2.5a2 2 0 00-2 2zm5.672-1a1 1 0 01.707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 011-.98h3.672z' />
			<path d='M13.5 10a.5.5 0 01.5.5V12h1.5a.5.5 0 110 1H14v1.5a.5.5 0 11-1 0V13h-1.5a.5.5 0 010-1H13v-1.5a.5.5 0 01.5-.5z' />
		</svg>
	);
}

export default SvgFolderPlus;
